import { useStore } from '@spazious/dollhouse-store';
import { useEventCallback } from '@spazious/react-hooks';

import { createFeatureChecker } from '../../utils/index.js';

export const useFeatures = () => {
  const enabledFeatures = useStore(({ features }) => features);

  const hasFeature = useEventCallback(createFeatureChecker(enabledFeatures));

  return {
    hasFeature,
    enabledFeatures,
  };
};
